/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Illegal_Transaction_Content_CnaInputs */

const en_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const ar_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const de_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const es_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const fr_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const it_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const ja_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const ko_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const pt_br_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const ru_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const th_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const tr_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const zh_cn_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款已完成，但 Plus 会员资格尚未与 Forest 账号连结。别担心！请点击“恢复购买”来解决这个问题。`)
};

const zh_tw_dialog_illegal_transaction_content_cna = /** @type {(inputs: Dialog_Illegal_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款已完成，但 Plus 会员资格尚未与 Forest 账号连结。别担心！请点击“恢复购买”来解决这个问题。`)
};

/**
* | output |
* | --- |
* | "Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this." |
*
* @param {Dialog_Illegal_Transaction_Content_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_illegal_transaction_content_cna = /** @type {((inputs?: Dialog_Illegal_Transaction_Content_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Illegal_Transaction_Content_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "ar") return ar_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "de") return de_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "es") return es_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "fr") return fr_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "it") return it_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "ja") return ja_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "ko") return ko_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "pt_br") return pt_br_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "ru") return ru_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "th") return th_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "tr") return tr_dialog_illegal_transaction_content_cna(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_illegal_transaction_content_cna(inputs)
	return zh_tw_dialog_illegal_transaction_content_cna(inputs)
});